module.exports = __webpack_public_path__ + "media/images/icons/star-icon_dark-65e687742caf5762a261c0fdb22f5db6.svg";